import React, { useState } from 'react'
import { UploadOutlined } from '@ant-design/icons'
import { Button, Form, Modal, Upload } from 'antd'
import { assignMessage, errorMessage, getTournamentMatchData, successMessage, warningMessage } from '../../../utils/helpers'
import { POST } from '../../../utils/apis'
import axios from 'axios'
import { currencySign } from '../../../utils/constants'

const ClaimMatchModal = (props) => {
    const { selectedLanguage, language, onCancel, user, data, visible, handleOk, userActions } = props
    const [fileList, setFileList] = useState([])
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    console.log('language==', language)

    const onFinish = (values) => {

        values.file = fileList
        values.userId = user?._id

        if (!values._id && !values?.file?.length) {
            return warningMessage(selectedLanguage?.PleaseUploadImage)
        }
        setLoading(true)

        let formData = new FormData()
        if (values?.file?.length) {
            formData.append('file', values?.file[0])
        }
        formData.append('_id', data?._id)
        formData.append('userId', values?.userId)

        axios.post(POST.SUBMIT_WIN_PROOF, formData)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data?.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    getTournamentMatchData(user?._id, userActions)
                    onCancel()
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
            })
            .catch((e) => {
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
                console.log('e', e)
            })
    }

    const normFile = (e) => {
        setFileList([])

        if (e?.fileList?.length && e?.file?.type !== 'image/png' && e?.file?.type !== 'image/jpeg') {
            errorMessage(selectedLanguage?.YouCanOnlyUploadImages)
            return []
        }

        if (Array.isArray(e)) {
            return e
        }

        e?.fileList?.length ? setFileList([...[e?.file]]) : setFileList([])
        return e && [e.file]
    }

    return (
        <Modal
            open={visible}
            onOk={handleOk}
            onCancel={handleOk}
            footer={null}>
            <div style={{ marginTop: '10px' }}>
                <span style={{ textAlign: 'center' }}>
                    <p className='admin-home-title' style={{ fontSize: '18px' }}>{selectedLanguage?.title_AddProveOfMatchThatYouWin}</p>
                </span>
            </div>
            <div className='border-line' />
            <div>
                <p className='admin-home-title' style={{ fontSize: '18px', marginBottm: '15px' }}>{selectedLanguage?.text_GameDetail}</p>
                <p className='p-none-margin'><p className='p-none-margin-bolder'>{selectedLanguage?.text_NickName}</p>: {data?.gameId?.name}</p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.title_Description} </p>: {data?.gameId?.description}</p>
            </div>
            <div>
                <p className='admin-home-title' style={{ fontSize: '18px', marginBottm: '15px' }}>{selectedLanguage?.text_MatchDetail}</p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.text_MatchDateTime} </p>: {data?.matchDate} | {data?.matchTime}</p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.text_MessagefromSender} </p>: {data?.message}</p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{data?.isStake ? selectedLanguage?.text_money : selectedLanguage?.text_Points} </p>: {data?.isStake ? `${currencySign} ${data?.money}` : data?.points}</p>
            </div>
            <div>
                <p className='admin-home-title' style={{ fontSize: '18px', marginBottm: '15px' }}>{selectedLanguage?.text_Requestsenderdetail}</p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.txt_Name} </p>: {data?.senderId?.name} </p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.txt_Email} </p>: {data?.senderId?.email}</p>
            </div>
            <div>
                <p className='admin-home-title' style={{ fontSize: '18px', marginBottm: '15px' }}>{selectedLanguage?.txt_Resuest_oponent_detail}</p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.txt_Name} </p>: {data?.receiverId?.name} </p>
                <p className='p-none-margin'> <p className='p-none-margin-bolder'>{selectedLanguage?.txt_Email} </p>: {data?.receiverId?.email}</p>
            </div>
            <div className='border-line' />
            <div style={{ marginTop: '20px' }}>
                <span style={{ textAlign: 'center' }}>
                    <p className='admin-home-title' style={{ fontSize: '18px' }}>{selectedLanguage?.text_AddProveofwinning}</p>
                </span>
                <Form
                    name='form'
                    form={form}
                    onFinish={onFinish}
                    layout={'vertical'}
                >
                    <div className='form-two-input-flex-inner-input' style={{ width: '100%' }}>
                        <Form.Item
                            name='file'
                            label={selectedLanguage?.text_winningproof}
                        >
                            <Upload
                                name='file'
                                multiple={false}
                                beforeUpload={() => false}
                                accept='image/*'
                                onChange={normFile}
                                fileList={fileList}
                            >
                                <Button icon={<UploadOutlined />}>{selectedLanguage?.text_clicktouploadproof}</Button>
                            </Upload>
                        </Form.Item>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Form.Item>
                            <Button
                                type='primary'
                                htmlType='submit'
                                loading={loading}
                            >
                                {selectedLanguage?.text_SendtoAdmin}
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </div>
        </Modal>
    )
}

export default ClaimMatchModal